import * as idb from 'idb';

const DB_NAME = 'kpi-store';
const MY_KPIS_STORE = 'my-kpis';
const GROUP_KPIS_STORE = 'group-kpis';

const dbPromise = idb.openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(MY_KPIS_STORE);
    db.createObjectStore(GROUP_KPIS_STORE);
  },
});
export const storeMyKpis = async (kpis) => {
  const db = await dbPromise;
  await db.put(MY_KPIS_STORE, kpis, 'current');
};

export const getStoredMyKpis = async () => {
  const db = await dbPromise;
  return db.get(MY_KPIS_STORE, 'current');
};

export const deleteMyKpis = async () => {
  const db = await dbPromise;
  return db.delete(MY_KPIS_STORE, 'current');
};

export const updateMyKpis = async (newScore) => {
  const db = await dbPromise;
  const currentKpis = await db.get(MY_KPIS_STORE, 'current');
  
  if (currentKpis) {
    // Create updated month object starting with existing data
    const updatedMonth = {
      ...currentKpis.month
    };

    // Merge new KPI scores
    Object.entries(newScore).forEach(([kpiId, scoreData]) => {
      updatedMonth[kpiId] = {
        pts: (updatedMonth[kpiId]?.pts || 0) + scoreData.pts,
        amt: (updatedMonth[kpiId]?.amt || 0) + scoreData.amt
      };
    });

    // Recalculate total from all KPI points
    const total = Object.values(updatedMonth)
      .reduce((sum, score) => {
        // Skip the 'total' property itself
        if (typeof score === 'object' && score.pts) {
          return sum + score.pts;
        }
        return sum;
      }, 0);

    // Update the month object with new total
    updatedMonth.total = total;

    const updatedKpis = {
      ...currentKpis,
      month: updatedMonth
    };

    await db.put(MY_KPIS_STORE, updatedKpis, 'current');
    return updatedKpis;
  }
  return null;
};

export const storeGroupKpis = async (kpis) => {
  const db = await dbPromise;
  await db.put(GROUP_KPIS_STORE, kpis, 'current');
};

export const getStoredGroupKpis = async () => {
  const db = await dbPromise;
  return db.get(GROUP_KPIS_STORE, 'current');
};